import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";


const ResvInQueuePopUP = (props) => {

    const { t } = props
    
    return (
        <section class="overlay">
			<div class="overlay-window-container">
				<div class="overlay-window">
					<div class="overlay-content padding-0">
						<div class="overlay-header">
							<div class="overlay-header-title">
								<h2 style={{color: "#000 !important"}}>Attention</h2>
							</div>
							<div class="overlay-header-icon">
								<i class="fas fa-exclamation"></i>
							</div>
						</div>
						<div class="overlay-header-body">
                            <p>{props.errorMsg}</p>
							<p>{t('check_in.resv_queue_popup_message')}</p>
						</div>
					</div>
					<div class="overlay-controls">
						<button onClick={() => props.backBtn()} class="button w-100">{t('check_in.close')}</button>
					</div>
				</div>
			</div>
		</section>
    )
}

const mapStateToProps = state => {
    return {
      menuColor: state.store.home.MenuColor,
    }
  }

export default connect(mapStateToProps,{})(withTranslation('translations')(ResvInQueuePopUP));